import { GetServerSideProps } from 'next'
export { NextRouteComponent as default } from '@pankod/refine-nextjs-router'
import { checkAuthentication } from '@pankod/refine-nextjs-router'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'

import dataProvider from 'src/dataProvider'
import { authProvider } from 'src/authProvider'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { isAuthenticated, ...props } = await checkAuthentication(
    authProvider,
    context,
  )

  if (!isAuthenticated) {
    return props
  }

  const translateProps = await serverSideTranslations(context.locale ?? 'id', [
    'common',
  ])

  const { query } = context

  if (query['resource'] === 'panduan-lms-admin') {
    return {
      props: translateProps,
    }
  }

  try {
    const data = await dataProvider(process.env.LMS_API_URL).getList({
      resource: query['resource'] as string,
    })

    return {
      props: {
        ...translateProps,
        initialData: data,
      },
    }
  } catch {
    return {
      props: { ...translateProps, initialData: [] },
    }
  }
}
